<template>
	<main>
		<div ref="parentElm">
			<div class="pd-both">
				<div class="md-layout sort-order-xsmall-100">
					<div class="md-layout-item">
						<label for="sortOrder">Sort Order</label>
						<div class="inline-sort w-25 " @click="changeSortOrder()">
							<p v-text="`${sortOrder == -1 ? 'Newest First' : 'Oldest First'}`" class="sorter"></p>
							<font-awesome-icon class='small-icon m-left-5' icon="caret-down" v-if="sortOrder == -1" />
							<font-awesome-icon class='small-icon m-left-5' icon="caret-up" v-if="sortOrder != -1" />
						</div>
					</div>
					<div class="md-layout-item" v-if="!isHome">
						<md-field class="align-right create-community w-50">
							<md-select @md-closed="loadData()" name="community" placeholder="Community" v-model="selectedCommunity" id="community" aria-label="Select community to filter">
								<md-option value="all">All</md-option>
								<md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name}}</md-option>
							</md-select>
						</md-field>
					</div>
				</div>
			</div>
			<div class="pd-both">
			</div>

			<div v-if="this.asks.length <= 0">
				<md-empty-state
												md-label="Loading..."
												md-description="Please wait for data to load or try a different search.">
				</md-empty-state>
			</div>
			<div class="content-panel" @click.stop="unselectExpanded" id="infinite-list">
				<div class="inbox">
					<div v-for="(ask, index) in asks" @click.stop="swapExpanded(index)" :key="ask._id">
						<ask-row v-if="index != selectedRow" :allOwners="allOwners" :term="myterm" :ask="ask">Ask goes here...</ask-row>
						<ask-tile v-if="index == selectedRow" :allOwners="allOwners" :term="myterm" :ask="ask">Ask goes here...</ask-tile>
					</div>
				</div>
			</div>
			<md-button class="md-fab loadmore-button" v-on:click="loadMore()" v-if="skip + limit < count" aria-label="Load more inbox items">
				<md-tooltip md-direction="left">Load more</md-tooltip>
				<md-icon>
					<font-awesome-icon icon="recycle" />
				</md-icon>
			</md-button>
		</div>
	</main>
</template>
<script>
import AskRow from "./AskRow";
import AskTile from "./AskTile";
import API from "../services/API";
export default {
	name: "Inbox",
	components: {
		AskRow,
		AskTile
	},
	props: ["view"],
	data() {
		return {
			asks: [],
			selectedRow: -1,
			sortOrder: -1,
			api: new API(),
			fullPage: true,
			skip: 0,
			limit: 25,
			count: 0,
			allCommunities: [],
			selectedCommunity: localStorage.getItem('community_id') || "",
			allOwners: [],
			myterm: ""
		};
	},
	watch: {
		$route: "updateDefaults"
	},
	computed: {
		isHome() {
			return this.$route.path === '/' || this.$route.path === '/home';
		}
	},
	async created() {
		this.loadData();
		await this.getAllOwners();
		if (!this.isHome) {
			this.getAllCommunity();
		}
		this.$on("Reload", () => {
      this.loadData();
    });
	},
	methods: {
		loadData: async function () {
			let url = '';
			if (this.$route.query.term) {
				url = `asks/${this.view}&limit=${this.limit}&skip=${this.skip}&sort=${this.sortOrder}&community=${this.selectedCommunity}`
			} else {
				if (this.$route.query.s) {
					url = `asks/search?s=${this.$route.query.s}&limit=${this.limit}&skip=${this.skip}&sort=${this.sortOrder}&community=${this.selectedCommunity}`;
				} else {
					url = `asks/${this.view}?limit=${this.limit}&skip=${this.skip}&sort=${this.sortOrder}&community=${this.selectedCommunity}`
				}
			}
			await this.api.get(url).then(asks => {
				if (asks.data instanceof Object || asks.data instanceof Array) {
					this.count = asks.data.count;
					this.asks = asks.data.asks;
				}
			});
		},
		updateDefaults: async function () {
			this.skip = 0;
			this.limit = 25;
			this.count = 0;
			this.asks = [];
			if (!this.isHome && this.allCommunities.length === 0) {
				this.getAllCommunity();
			}
			this.loadData();
		},
		getAllCommunity: async function () {
			const api = new API();
			if (api.headers && api.headers.headers) {
				delete api.headers.headers['x-tenant-id'];
			}

			try {
				const response = await api.get('tenants');
				if (response.data && response.data.data) {
					let allCommunities = response.data.data.map(t => ({
						_id: t.communityId,
						name: t.communityName
					}));

					const authUser = JSON.parse(localStorage.getItem('authUser'));
					if (authUser) {
						const role = authUser.role ? authUser.role.toLowerCase() : '';
						if (role !== 'superadmin') {
							const userCommunityIds = authUser.communities || [];
							allCommunities = allCommunities.filter(c => userCommunityIds.includes(c._id));
						}
					}

					this.allCommunities = allCommunities.sort((a, b) => a.name.localeCompare(b.name));
				}
			} catch (error) {
				console.error("Error fetching communities for filter:", error);
				await this.api.get(`communities/all`).then(communities => {
					this.allCommunities = communities.data;
				});
			}
		},
		getAllOwners: async function () {
			await this.api.post(`configuration/get-configuration/protopia-owner`).then(owners => {
				this.allOwners = owners.data.getData.sort((a, b) => a.email > b.email ? 1 : -1);
			});
		},
		swapExpanded: function (i) {
			this.selectedRow = i;
		},
		unselectExpanded: function () {
			this.selectedRow = -1;
		},
		changeSortOrder: async function (text) {
			this.sortOrder = this.sortOrder * -1;
			this.loadData();
		},
		async loadMore() {
			this.skip = this.skip + this.limit;
			if (this.skip < this.count) {
				this.loadData();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Inbox.vue